import React from "react";
import StringUtil, { convertFilePath } from "../../../utils/StringUtil";
import styled from "styled-components";
import { COLOR_SYSTEM } from "../../design/design-system";

type AvatarSize =
  | "XXSmall"
  | "XSmall"
  | "Small"
  | "Medium"
  | "Large"
  | "XLarge";

const SIZE = {
  XXSmall: 16,
  XSmall: 24,
  Small: 36,
  Medium: 48,
  Large: 60,
  XLarge: 60,
};

export interface AvatarProps {
  className?: string;
  size?: AvatarSize;
  base64?: string;
  url?: string;
  errorUrl?: string;
  anonymous?: boolean;
  border?: boolean;
  onClick?: () => any;
}

const BadgeWrapper = styled.img<AvatarProps>`
  height: ${({ size }) => {
    return `${SIZE[size]}px`;
  }};
  width: ${({ size }) => {
    return `${SIZE[size]}px`;
  }};
  min-height: ${({ size }) => {
    return `${SIZE[size]}px`;
  }};
  min-width: ${({ size }) => {
    return `${SIZE[size]}px`;
  }};
  border-radius: ${({ size }) => {
    return `${SIZE[size] / 2}px`;
  }};
  ${({ border }) =>
    border ? `border: 1px solid ${COLOR_SYSTEM.get("Gray")[50]};` : ""}
`;

const Avatar = ({
  className,
  base64,
  url,
  anonymous,
  onClick,
  errorUrl,
  size = "Medium",
  border = false,
}: AvatarProps) => {
  if (anonymous) {
    return (
      <BadgeWrapper
        border={border}
        size={size}
        className={className}
        src="/images/profile_anonymous.png"
        onClick={() => {
          if (onClick) onClick();
        }}
        onError={(e) => {
          let targetAny: any = e.target;
          targetAny.src = errorUrl ? errorUrl : "/images/profile_anonymous.png";
        }}
      />
    );
  } else if (base64) {
    return (
      <BadgeWrapper
        border={border}
        size={size}
        className={className}
        src={base64}
        onClick={() => {
          if (onClick) onClick();
        }}
        onError={(e) => {
          let targetAny: any = e.target;
          targetAny.src = errorUrl ? errorUrl : "/images/profile_anonymous.png";
        }}
      />
    );
  } else if (url) {
    let profilePath = url;
    profilePath = convertFilePath(profilePath);

    if (profilePath.startsWith("http://k.kakaocdn.net/")) {
      profilePath = profilePath.replace(
        "http://k.kakaocdn.net/",
        "https://k.kakaocdn.net/"
      );
    }
    return (
      <BadgeWrapper
        border={border}
        size={size}
        className={className}
        src={profilePath}
        onClick={() => {
          if (onClick) onClick();
        }}
        onError={(e) => {
          let targetAny: any = e.target;
          targetAny.src = errorUrl ? errorUrl : "/images/profile_anonymous.png";
        }}
      />
    );
  } else {
    return (
      <BadgeWrapper
        border={border}
        size={size}
        className={className}
        src={errorUrl ? errorUrl : "/images/profile_anonymous.png"}
        onClick={() => {
          if (onClick) onClick();
        }}
        onError={(e) => {
          let targetAny: any = e.target;
          targetAny.src = errorUrl ? errorUrl : "/images/profile_anonymous.png";
        }}
      />
    );
  }
};

export default Avatar;
